import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";
import { getHeader, getUserInfo } from '../../../utility/index';
interface DecodedToken {
  emp_id: string;
}



export const getAllOffers = async (
  page: number,
  size: number,
  params: any
): Promise<any> => {
  let url = "";
  if (params.search)
    url = `/admin/offers?page=${page}&size=${size}&search=${params.search}`;
  else url = `/admin/offers?page=${page}&size=${size}`;

  const response = await axios.post<any>(
    url,
    {}, // empty POST body
    {
      headers: getHeader(), // ✅ correct placement
    }
  );

  return response.data;
};


export const addnewOffers = async (formData: FormData): Promise<any> => {
  let url = `/admin/offers/upload`;
  const response = await axios.post<any>(url, formData, {
   headers: getHeader(),
  });
  return response.data;
};

export const deleteOffer = async (id: number): Promise<any> => {
  let url = `/admin/offers/${id}`;
  const response = await axios.delete<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};
